import Alpine from 'alpinejs'

export const C7Cart = () => ({
  bottles: 0,
  observer: null,
  pollInterval: null,

  init() {
    // Initialize the Alpine store if it doesn't exist
    if (!Alpine.store('cartCount')) {
      Alpine.store('cartCount', 0)
    }

    // Listen for potential Commerce7 events (if they exist)
    this.listenForC7Events()

    // Wait for Commerce7 elements to load, then start observing
    this.waitForElement('.c7-user-nav__cart__count', (element) => {
      this.updateBottleCount()
      this.startObserver(element)
    })
  },

  listenForC7Events() {
    // Listen for potential Commerce7 cart events
    const eventTypes = [
      'c7:cart:updated',
      'c7:cart:item:added',
      'c7:cart:item:removed',
      'cart:updated',
      'cartUpdated',
    ]
    eventTypes.forEach((eventType) => {
      document.addEventListener(eventType, () => {
        this.updateBottleCount()
      })
    })
  },

  waitForElement(selector, callback) {
    const element = document.querySelector(selector)
    if (element) {
      callback(element)
    } else {
      // Check every 100ms for up to 10 seconds
      const interval = setInterval(() => {
        const element = document.querySelector(selector)
        if (element) {
          clearInterval(interval)
          callback(element)
        }
      }, 100)

      // Stop trying after 10 seconds
      setTimeout(() => clearInterval(interval), 10000)
    }
  },

  startObserver(element) {
    // Clean up existing observers
    this.cleanup()

    // Strategy 1: MutationObserver on the cart count element
    const observer = new MutationObserver(() => {
      this.updateBottleCount()
    })
    const config = {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    }
    observer.observe(element, config)

    // Strategy 2: Also observe the parent cart container in case the element gets replaced
    const cartContainer = document.querySelector('#c7-cart')
    if (cartContainer) {
      const containerObserver = new MutationObserver(() => {
        // Wait a bit for DOM to settle, then update
        setTimeout(() => this.updateBottleCount(), 100)
      })
      containerObserver.observe(cartContainer, {
        childList: true,
        subtree: true,
      })
    }

    // Store observers for cleanup
    this.observer = observer

    // Strategy 3: Reduced polling fallback - check every 10 seconds as safety net
    this.pollInterval = setInterval(() => {
      const currentElement = document.querySelector('.c7-user-nav__cart__count')
      if (currentElement && currentElement !== element) {
        this.startObserver(currentElement)
      }
      this.updateBottleCount()
    }, 10000)
  },

  cleanup() {
    if (this.observer) {
      this.observer.disconnect()
      this.observer = null
    }
    if (this.pollInterval) {
      clearInterval(this.pollInterval)
      this.pollInterval = null
    }
  },

  updateBottleCount() {
    const cartElement = document.querySelector('.c7-user-nav__cart__count')
    if (!cartElement) {
      return
    }

    const cartText = cartElement.innerHTML || cartElement.textContent || '0'
    const bottles = parseInt(cartText) || 0

    // Only update if value actually changed
    if (this.bottles !== bottles) {
      this.bottles = bottles
      Alpine.store('cartCount', bottles)
      this.callback()
    }
  },

  callback() {
    this.$dispatch('cart-count-updated')
  },
})
